import { render, staticRenderFns } from "./assetDetail.vue?vue&type=template&id=9e3bf70a&scoped=true&"
import script from "./assetDetail.vue?vue&type=script&lang=js&"
export * from "./assetDetail.vue?vue&type=script&lang=js&"
import style0 from "./assetDetail.vue?vue&type=style&index=0&id=9e3bf70a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3bf70a",
  null
  
)

export default component.exports